import { apiRequest } from "./client";

export function listFowebProductCats() {
  return apiRequest("/fowebproductcats");
}
